import { render, staticRenderFns } from "./notification.vue?vue&type=template&id=1e829f04&scoped=true"
import script from "./notification.vue?vue&type=script&lang=js"
export * from "./notification.vue?vue&type=script&lang=js"
import style0 from "./notification.vue?vue&type=style&index=0&id=1e829f04&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e829f04",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/gameclient/gameclient/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1e829f04')) {
      api.createRecord('1e829f04', component.options)
    } else {
      api.reload('1e829f04', component.options)
    }
    module.hot.accept("./notification.vue?vue&type=template&id=1e829f04&scoped=true", function () {
      api.rerender('1e829f04', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/popup/notification.vue"
export default component.exports